var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('center',[_c('h3',[_vm._v("Hola soy el delete hotels")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-907e8bc6","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/Hotels/Delete.vue
// module id = 762
// module chunks = 2